export const EVENT_TYPES = {
    IS_LIVE: 'isLive',
    COMING_SOON: 'comingSoon',
    ON_DEMAND: 'onDemand',
    OFFLINE: 'offLine'

}